import React from "react";
import AccountLayoutHolder from "./accountLayout.styles";

const AccountLayout = ({ children }) => {
  return (
    <AccountLayoutHolder>
      <div className="accountLayout__inner">
        <div className="accountLayout__content">{children}</div>
      </div>
    </AccountLayoutHolder>
  );
};

export default AccountLayout;
